import { render, staticRenderFns } from "./otherModal.vue?vue&type=template&id=72f56b84&scoped=true&"
import script from "./otherModal.vue?vue&type=script&lang=js&"
export * from "./otherModal.vue?vue&type=script&lang=js&"
import style0 from "./otherModal.vue?vue&type=style&index=0&id=72f56b84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f56b84",
  null
  
)

export default component.exports